import React from 'react'
import { ApolloQueryResult, useMutation } from '@apollo/client'
import { RemoveGroupMember, RemoveGroupMemberVariables } from '../../types'
import { REMOVE_GROUP_MEMBER } from './operations'

interface RemoveGroupHandlerProps {
  userId: string
  groupId: string
  refetchQuery: () => Promise<ApolloQueryResult<unknown>> | void
}

interface Props {
  onSuccess?: ({ userId }: { userId: string }) => void
}

export const useRemoveGroupMember = ({ onSuccess }: Props = {}) => {
  const [isRefetching, setIsRefetching] = React.useState(false)
  const [removeGroupMember, { loading: isLoadingRemoveGroupMember }] = useMutation<
    RemoveGroupMember,
    RemoveGroupMemberVariables
  >(REMOVE_GROUP_MEMBER)

  const handleRemoveGroupMember = async ({
    userId,
    groupId,
    refetchQuery,
  }: RemoveGroupHandlerProps) => {
    try {
      await removeGroupMember({
        variables: {
          inputData: {
            groupId,
            userId,
          },
        },
      })
      onSuccess?.({ userId })
      setIsRefetching(true)
      await refetchQuery()
      setIsRefetching(false)
    } catch {
      // ignore
    }
  }

  return {
    isRefetching,
    isLoadingRemoveGroupMember,
    handleRemoveGroupMember,
  }
}
